import React, {useEffect, useState} from 'react';
import {Controller, SubmitHandler, useForm} from 'react-hook-form';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Tooltip,
    Typography,
} from '@mui/material';
import {yupResolver} from '@hookform/resolvers/yup';
import {
    useCreateVersOre2,
    useGetAppUserProgettiDTO,
    useGetVersOre2,
    useUpdateVersOre2,
    validationSchemaVersOre2
} from './Services';
import {VersOre2} from './types';
import * as Yup from "yup";
import {FormField} from '../../common/FormField';
import {  useFieldsVersOre2_1,  useFieldsVersOre2_2,  useFieldsVersOre2_3,  useFieldsVersOre2_4,  useFieldsVersOre2_5} from './FormVersOre2';
import {useGetVersOre} from "../gestversore/Services";
import ReportProg from "../reports/ReportProg";
import SummarizeIcon from "@mui/icons-material/Summarize";
import VersOreNoteAssist, {clampVersOreNote, loadVersOreCopilotConfig} from "../gestversore/VersOreNoteAssist";

interface EditVersOre2Props {
  open: boolean;
  onClose: () => void;
  id: number;

}

const EditVersOre2: React.FC<EditVersOre2Props> = ({ open, onClose, id   }) => {

      type VersOre2Form = Yup.InferType<typeof validationSchemaVersOre2>


  const { control, handleSubmit, reset,watch,setValue, formState: { errors }} = useForm<VersOre2Form>({
    resolver: yupResolver(validationSchemaVersOre2),
     defaultValues: {
               },
  });

const [indclibloc, setIndclibloc] = useState<number>(0);

// const isBlocked = indclibloc === 2;
const isBlocked = false;


// console.log(errors);
const [openReport, setOpenReport] = useState(false);

  const { data, isLoading } = useGetVersOre2(id);

 useEffect(() => {
  if (!data) return;

  const codprog = data.codprog?.trim() ?? "";
  const codnodo = data.codnodo?.trim() ?? "";
  const codatt  = data.codatt?.trim() ?? "";

  const idprog = `${data.ditta}-${codprog}`;
  const idnodo = `${data.ditta}-${codprog}-${codnodo}`;
  const idatt  = `${data.ditta}-${codprog}-${codatt}`;

  reset({
            ...data,
            idprog,
            idnodo,
            idatt,
            opzione: data.opzione?.trim(),
            luogo: data.luogo?.trim(),

          });
  }, [data, reset]);


  const watchLuogo = watch('luogo');
  const watchOreStraord = watch('orestraord');
  const watchMinStraord = watch('minstraord');
  const watchIdProg = watch("idprog");

   const keycoddip = localStorage.getItem("keycoddip") || "";

   const { data: appUserProgDTO } = useGetAppUserProgettiDTO(
      watchIdProg,
      keycoddip
    );

// console.log(data);

  const molt =  parseFloat(String(appUserProgDTO?.results?.[0]?.molt).replace(",", ".")) || 1;

  useEffect(() => {
  const ore = Number(watchOreStraord) || 0;
  const minuti = Number(watchMinStraord) || 0;
  const moltiplicatore = molt || 1;

  // 1️⃣ Converto tutto in minuti
  const minutiTotali = (ore * 60 + minuti) * moltiplicatore;

  // 2️⃣ Converto in ore arrotondate per eccesso
  let oreCalcolate = Math.ceil(minutiTotali / 60);

  // 3️⃣ Regola TRASFERTA applicata DOPO il calcolo
  if (watchLuogo === 'TRASFERTA') {
    oreCalcolate = oreCalcolate <= 4 ? 4 : 8;
  }
  setValue("oreord", oreCalcolate);

}, [watchOreStraord, watchMinStraord, watchLuogo, molt,setValue]);




  const editOpzione = true;

  const f1 = useFieldsVersOre2_1(editOpzione,isBlocked);
  const f2 = useFieldsVersOre2_2(watchIdProg,setValue,setIndclibloc,isBlocked);  //non usato vedi blocco form solo per comp con addd
  const f3 = useFieldsVersOre2_3(isBlocked);
  const f4 = useFieldsVersOre2_4(isBlocked);
  const f5 = useFieldsVersOre2_5(isBlocked);


  const { mutateAsync, isPending } = useUpdateVersOre2();

  const onSubmit: SubmitHandler<VersOre2Form> = async data => {
    // console.log("FINAL FORM DATA:", data);
    const copilotConfig = await loadVersOreCopilotConfig();

    const codprog = data.idprog?.split("-")[1] ?? "";
    const codnodo = data.idnodo?.split("-")[2] ?? "";
    const codatt  = data.idatt?.split("-")[2] ?? "";
    const ditta = Number(data.idprog?.split("-")[0]) || 0;
    // const coddip = localStorage.getItem('keycoddip') || '';



    const payload = {
                  ...data,
                  indlavoraz: 0,
                  indora: 0,
                  indtipovers: 2,
                  valutadqr: "EURO",
                  umtempodqr: 2,
                  indtipocosdqr: 0,
                  costodqr: 30,
                  impdqr: 90,
                  protocollo: 1037,
                  // coddip: localStorage.getItem("coddip") || "",
                  minord: 0,
                  ditta,
                  codprog,
                  codnodo,
                  codatt,
                  note: clampVersOreNote(data.note || '', copilotConfig.noteMaxLength).value,
                  // coddip,
                };

    ;

    await mutateAsync(payload as VersOre2);
    onClose();
  };





  return (
      <>
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
   <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h6">Edit Time Report</Typography>
           {watchIdProg && (
                              <Tooltip title="Report Nodi Progetto" arrow>
                                  <IconButton
                                    size="large"
                                    color="primary"
                                    onClick={() => setOpenReport(true)}
                                  >
                                    <SummarizeIcon sx={{ fontSize: 30 }} />
                                  </IconButton>
                              </Tooltip>
                                )}
      </DialogTitle>

      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={1}>
            <Stack direction="row" spacing={1}>{f1.map(f => <FormField key={String(f.name)} control={control} field={f} />)}</Stack>
            <Stack direction="column" spacing={1}>{f2.map(f => <FormField key={String(f.name)} control={control} field={f} />)}</Stack>
            <Stack direction="row" spacing={1}>{f3.map(f => <FormField key={String(f.name)} control={control} field={f} />)}</Stack>
            <Stack direction="row" spacing={1}>{f4.filter(f => f.name !== "note").map(f => <FormField key={String(f.name)} control={control} field={f} />)}</Stack>
            <Controller
              name="note"
              control={control}
              render={({ field, fieldState }) => (
                <VersOreNoteAssist
                  textFieldId="versore2-edit-note"
                  value={String(field.value || '')}
                  onChange={field.onChange}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  disabled={isBlocked}
                />
              )}
            />
            <Stack direction="row" spacing={1}>{f5.map(f => <FormField key={String(f.name)} control={control} field={f} />)}</Stack>
            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button onClick={onClose} color="error">Annulla</Button>
              <Button type="submit" variant="contained" disabled={isPending}>
                {isPending ? 'Salvando…' : 'Salva'}
              </Button>
            </Stack>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
    <Dialog
      open={openReport}
      onClose={() => setOpenReport(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Report Nodi Progetto</DialogTitle>

      <DialogContent>
       <ReportProg key={watchIdProg} idprogprop={watchIdProg} />
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpenReport(false)}>Chiudi</Button>
      </DialogActions>
    </Dialog>
  </>
  );
};

export default EditVersOre2;
